// Indicative solar estimate logic for UK homes.
export const PANEL_WATTAGE = 430;      // W per panel
export const PANEL_AREA = 2.0;         // m² per panel incl. spacing
export const USABLE_FACTOR = 0.65;     // usable roof after obstructions/orientation
export const KWH_PER_KWP = 950;        // annual generation per kWp (UK average)
export const ELEC_PRICE = 0.28;        // £/kWh import
export const EXPORT_PRICE = 0.15;      // £/kWh export (SEG)
export const COST_PER_KWP = 1500;      // £ install cost per kWp (panels + install)

export const BATTERY_OPTIONS = [
  { key: "none", label: "No battery", capacity: 0, cost: 0, desc: "Use solar as it's generated." },
  { key: "small", label: "Small — 5 kWh", capacity: 5, cost: 2500, desc: "Great for smaller households." },
  { key: "medium", label: "Medium — 10 kWh", capacity: 10, cost: 4200, desc: "Most popular for families." },
  { key: "large", label: "Large — 15 kWh", capacity: 15, cost: 5800, desc: "Maximise self-sufficiency." },
];

export const BATTERY_LOCATIONS = ["Garage", "Utility room", "Loft", "Under stairs", "External wall", "Garden / outbuilding"];

export function calcEstimate({ roofArea, batteryKey, monthlyBill, annualUsageKwh, usageType, solarData }) {
  let panelCount, systemKwp, annualGeneration;

  if (solarData && solarData.panelCount) {
    panelCount = solarData.panelCount;
    const pw = solarData.panelCapacityWatts || PANEL_WATTAGE;
    systemKwp = +((panelCount * pw) / 1000).toFixed(2);
    annualGeneration = Math.round(solarData.annualGeneration || systemKwp * KWH_PER_KWP);
  } else {
    const usable = Math.max(roofArea * USABLE_FACTOR, 0);
    panelCount = Math.floor(usable / PANEL_AREA);
    systemKwp = +((panelCount * PANEL_WATTAGE) / 1000).toFixed(2);
    annualGeneration = Math.round(systemKwp * KWH_PER_KWP);
  }

  const battery = BATTERY_OPTIONS.find((b) => b.key === batteryKey) || BATTERY_OPTIONS[0];
  const hasBattery = battery.capacity > 0;

  // annual household usage estimate
  let usage = 0;
  if (usageType === "kwh" && annualUsageKwh) usage = Number(annualUsageKwh);
  else if (usageType === "bill" && monthlyBill) usage = (Number(monthlyBill) * 12) / ELEC_PRICE;

  const selfConsumptionFactor = hasBattery ? 0.75 : 0.4;
  const selfUsed = Math.min(annualGeneration * selfConsumptionFactor, usage || annualGeneration * selfConsumptionFactor);
  const exported = Math.max(annualGeneration - selfUsed, 0);

  const annualSavings = Math.round(selfUsed * ELEC_PRICE + exported * EXPORT_PRICE);
  const estimatedCost = Math.round(systemKwp * COST_PER_KWP + battery.cost);
  const paybackYears = annualSavings > 0 ? +(estimatedCost / annualSavings).toFixed(1) : null;

  return { panelCount, systemKwp, annualGeneration, estimatedCost, annualSavings, paybackYears, battery };
}
